import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { hasAny } from './acl';

export default function ProtectedRoute({ rights = [], children, fallback = '/' }) {
    const { loading, perms } = useAuth();
    if (loading) return null; // có thể đặt spinner tuỳ thích
    return hasAny(perms, rights) ? children : <Navigate to={fallback} replace />;
}
